/* eslint-disable no-unused-vars */
import {
  IconButton,
  Paper,
  Typography,
  Box,
  Grid
} from "@material-ui/core";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CancelIcon from "@material-ui/icons/Cancel";
// import { showHideSnackbar } from "../../../store/Snackbar/actions";
import { useIntl } from "react-intl";
import Button from "../../../components/Button";
import {
  addQuiz,
  editQuiz,
  getQuizDetails,
  checkForCanBeEditQuizRequest,
  checkForCanBeEditQuizResponse
} from "../../../store/Quizzes/actions";
import { useParams, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { FieldArray, Form, Formik } from "formik";
import {
  getInitialValuesAdd,
  getInitialValuesEdit,
  QUIZ_VALIDATIONSCHEMA,
  newEmptyQuestion,
  newAnswer
} from "./QuizValidations";
import Input from "../../../components/Input";
import "./AddEditQuiz.scss";
import MaterialPreview from "../../../components/MaterialPreview";
import Upload from "../../../components/Upload";
import { showHideSnackbar } from "../../../store/Snackbar/actions";
import { uploadToS3 } from "../../../utils/S3";
import QuizAnswerView from "./QuizAnswerView/QuizAnswerView";
import QuizAnswerForm from "./QuizAnswerForm/QuizAnswerForm";
import { showHideLoader } from "../../../store/Loader/actions";
const AddEditQuiz = ({ location }) => {
  const formRef = useRef();
  const uploadQuestionRef = useRef();
  const uploadJustificationRef = useRef();
  const { messages, locale } = useIntl();
  const {
    quizzes: { quizDetails }
  } = useSelector((state) => state);
  const CanBeEditQuiz = true;

  const { quizzes, buttons } = messages;
  const { id } = useParams();

  const dispatch = useDispatch();
  const [readOnly, setReadOnly] = useState(false);

  /* ------------------------ GETTING QUIZ IN EDIT MODE ----------------------- */
  useEffect(() => {
    if (id) {
      dispatch(getQuizDetails({ id }));
      dispatch(checkForCanBeEditQuizRequest({ id: id }));
    }
  }, [id]);
  useEffect(() => {
    return () => {
      dispatch(checkForCanBeEditQuizResponse(true));
    };
  }, []);

  /* VIEW 
  Depending on Alaa's code */
  useEffect(() => {
    if (location?.state?.mode === "view") setReadOnly(true);
  }, [location?.state?.mode]);

  // Forming Questions in edit mode

  const updatedQuestions = async (values) => {
    return await Promise.all(
      values.questions_attributes.map(async (question) => {
        const updatedQuestion = { ...question };

        // Handle question image
        try {
          if (updatedQuestion.image_url?.file instanceof File) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.image_url.file,
              updatedQuestion.image_url.file.name
            );
            updatedQuestion.image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload question image", err);
          updatedQuestion.image_url = null; // or keep the file
        }

        // Handle justification image
        try {
          if (
            updatedQuestion.justification_image_url?.file instanceof
            File
          ) {
            const { link } = await uploadToS3(
              "private",
              updatedQuestion.justification_image_url.file,
              updatedQuestion.justification_image_url.file.name
            );
            updatedQuestion.justification_image_url = link;
          }
        } catch (err) {
          console.error("Failed to upload justification image", err);
          updatedQuestion.justification_image_url = null;
        }

        // Handle answers
        updatedQuestion.answer_choices_attributes = await Promise.all(
          question.answer_choices_attributes.map(async (answer) => {
            const updatedAnswer = { ...answer };

            try {
              if (
                updatedAnswer.currentTab !== "text" &&
                updatedAnswer.image_url?.file instanceof File
              ) {
                const { link } = await uploadToS3(
                  "private",
                  updatedAnswer.image_url.file,
                  updatedAnswer.image_url.file.name
                );
                updatedAnswer.image_url = link;
              }
            } catch (err) {
              console.error("Failed to upload answer image", err);
              updatedAnswer.image_url = null;
            }

            return updatedAnswer;
          })
        );

        return updatedQuestion;
      })
    );
  };
  const handleSubmit = async (values) => {
    dispatch(showHideLoader(true));
    if (id) {
      try {
        values.questions_attributes = await updatedQuestions(values);
        dispatch(editQuiz(values));
      } catch (e) {
        console.error("Failed to prepare quiz data", e);
        // Optionally show a toast or error dialog
      }
      return;
    }

    try {
      values.questions_attributes = await updatedQuestions(values);

      dispatch(addQuiz(values));
    } catch (e) {
      console.error("Failed to prepare quiz data", e);
      // Optionally show a toast or error dialog
    }
  };

  async function handleUploadSingleImage(e, qIndex, AIndex, type) {
    let file = e?.target?.files[0];
    if (file) {
      if (file?.type?.includes("image")) {
        let url = URL.createObjectURL(file);
        let objFile = { file, url };

        if (type == "question") {
          formRef.current.setFieldValue(
            `questions_attributes[${qIndex}].image_url`,
            objFile
          );
          if (uploadQuestionRef.current)
            uploadQuestionRef.current.value = null;
        } else if (type == "justification") {
          formRef.current.setFieldValue(
            `questions_attributes[${qIndex}].justification_image_url`,
            objFile
          );
          if (uploadJustificationRef.current)
            uploadJustificationRef.current.value = null;
        }
        // Clear input value
        e.target.value = null;
      } else {
        dispatch(
          showHideSnackbar({
            type: "error",
            isOpen: true,
            message: "Please select image"
          })
        );
      }
    }
  }
  return (
    <Formik
      innerRef={formRef}
      initialValues={
        id ? getInitialValuesEdit(quizDetails) : getInitialValuesAdd()
      }
      onSubmit={(values) => handleSubmit(values)}
      validationSchema={QUIZ_VALIDATIONSCHEMA(locale)}
      enableReinitialize
    >
      {({ ...formik }) => {
        console.log("values", formik.values);
        console.log("errors", formik.errors);

        const totalPoints = formik?.values?.questions_attributes
          ?.filter((x) => !x._destroy)
          ?.reduce((acc, cur) => acc + Number(cur.points), 0);

        return (
          <div>
            <div className="mb-4">
              <Typography variant="h4" component="h1">
                {location?.state?.mode === "view"
                  ? formik.values.title
                  : id
                  ? quizzes.editQuiz
                  : quizzes.addQuiz}
              </Typography>
            </div>
            <fieldset
              disabled={readOnly || !CanBeEditQuiz}
              className={
                readOnly || !CanBeEditQuiz ? "disableFormEdit" : null
              }
            >
              <Box className="headerSectionQuiz">
                <div className="">
                  <Input
                    name="title"
                    label={"Quiz Title"}
                    // remove the * from field in the view mode
                    isRequired={!readOnly}
                  />
                  <div>
                    <Input
                      name="display_name"
                      label={"Display Name"}
                    />
                  </div>
                </div>
                <div className="">
                  <Input
                    name="total_points"
                    label={"Total Quiz Points"}
                    disabled={true}
                    value={totalPoints || ""}
                  />
                </div>
              </Box>

              <FieldArray name="questions_attributes">
                {({ push, replace, remove }) => {
                  return !formik?.values?.questions_attributes?.length
                    ? null
                    : formik?.values?.questions_attributes?.map(
                        (question, questionIndex, arr) => {
                          const lastActiveItem = [...arr]
                            .map((x) => x._destroy)
                            .map((x) => !!x)
                            .lastIndexOf(false);

                          const showAddButton =
                            lastActiveItem === questionIndex;

                          const error =
                            formik.errors.questions_attributes?.[
                              questionIndex
                            ];

                          return (
                            !question._destroy && (
                              <div
                                className="row align-items-center justify-content-center my-3"
                                key={question.id}
                              >
                                <div className="col-md-10 my-4">
                                  <Paper
                                    key={question.id}
                                    style={{ padding: "2rem" }}
                                    className="row align-items-center justify-content-center"
                                  >
                                    <div className="d-flex align-items-center justify-content-between">
                                      <div style={{ width: "100%" }}>
                                        <Input
                                          name={`questions_attributes[${questionIndex}].question`}
                                          label={
                                            readOnly
                                              ? quizzes?.questionTitle
                                              : "Add Question"
                                          }
                                          inputShape="textarea"
                                          rows="2"
                                        />
                                      </div>
                                      {!readOnly && (
                                        <a
                                          data-bs-toggle="collapse"
                                          href={`#collapseExample${questionIndex}`}
                                          role="button"
                                          aria-expanded="false"
                                          aria-controls="collapseExample"
                                          style={{
                                            width: "100px",
                                            marginLeft: "10px"
                                          }}
                                          className="mb-4"
                                        >
                                          {quizzes?.uploadImageLabel}
                                        </a>
                                      )}
                                    </div>
                                    <div
                                      className={
                                        !formik.values
                                          ?.questions_attributes[
                                          questionIndex
                                        ].image_url
                                          ? " collapse p-2 mb-2 "
                                          : "collapse show p-2 mb-2"
                                      }
                                      id={`collapseExample${questionIndex}`}
                                    >
                                      <div className="d-flex align-items-center justify-content-center">
                                        <Grid
                                          item
                                          className="pb-0"
                                          xs={6}
                                        >
                                          <div className="text-center">
                                            <div className="mb-3 d-flex flex-column align-items-center">
                                              <MaterialPreview
                                                type={1}
                                                isPublic={false}
                                                src={
                                                  question?.image_url
                                                    ?.url ||
                                                  question?.image_url
                                                }
                                                hasClear={
                                                  !readOnly &&
                                                  CanBeEditQuiz
                                                }
                                                onClear={() => {
                                                  formik.setFieldValue(
                                                    `questions_attributes[${questionIndex}].image_url`,
                                                    ""
                                                  );
                                                }}
                                              />
                                            </div>
                                            {!readOnly && (
                                              <Upload
                                                ref={
                                                  uploadQuestionRef
                                                }
                                                onChange={(e) =>
                                                  handleUploadSingleImage(
                                                    e,
                                                    questionIndex,
                                                    null,
                                                    "question"
                                                  )
                                                }
                                                label={
                                                  quizzes?.upload
                                                }
                                                name={`questions_attributes[${questionIndex}].image_url`}
                                                accept="image/*"
                                                isImage={true}
                                                setFieldValue={
                                                  formik.setFieldValue
                                                }
                                                isRequired={true}
                                                isMultiple={false}
                                              />
                                            )}
                                          </div>
                                        </Grid>
                                      </div>
                                    </div>
                                    <Input
                                      name={`questions_attributes[${questionIndex}].points`}
                                      label={"Points"}
                                      isNumber={true}
                                      type="number"
                                      value={
                                        formik.values
                                          .questions_attributes[
                                          questionIndex
                                        ].points === 0
                                          ? "0"
                                          : formik.values
                                              .questions_attributes[
                                              questionIndex
                                            ].points
                                      }
                                    />

                                    {typeof error?.answer_choices_attributes ===
                                      "string" && (
                                      <p className="error-msg mb-3">
                                        {
                                          error?.answer_choices_attributes
                                        }
                                      </p>
                                    )}

                                    <Typography
                                      variant="h6"
                                      component="h6"
                                      className="text-secondary my-4"
                                    >
                                      {quizzes?.answersOptions}
                                    </Typography>
                                    {/*Answer Section*/}
                                    {readOnly ? (
                                      <QuizAnswerView
                                        question={question}
                                        questionIndex={questionIndex}
                                      />
                                    ) : (
                                      <QuizAnswerForm
                                        mode={id ? "edit" : "add"}
                                        question={question}
                                        questionIndex={questionIndex}
                                        setFieldValue={
                                          formik.setFieldValue
                                        }
                                        formRef={formRef}
                                      />
                                    )}
                                    <div className="col-12">
                                      <Input
                                        name={`questions_attributes[${questionIndex}].justification`}
                                        label={"Explanation"}
                                        inputShape="textarea"
                                        rows="2"
                                      />
                                      <div className="mb-3 d-flex flex-column align-items-end w-60 gap-3">
                                        <MaterialPreview
                                          type={1}
                                          isPublic={false}
                                          src={
                                            question
                                              ?.justification_image_url
                                              ?.url ||
                                            question.justification_image_url
                                          }
                                          hasClear={
                                            !readOnly && CanBeEditQuiz
                                          }
                                          onClear={() => {
                                            formik.setFieldValue(
                                              `questions_attributes[${questionIndex}].justification_image_url`,
                                              ""
                                            );
                                          }}
                                        />
                                        {!readOnly && (
                                          <Upload
                                            ref={
                                              uploadJustificationRef
                                            }
                                            onChange={(e) =>
                                              handleUploadSingleImage(
                                                e,
                                                questionIndex,
                                                null,
                                                "justification"
                                              )
                                            }
                                            label={quizzes?.upload}
                                            name={`questions_attributes[${questionIndex}].justification_image_url`}
                                            accept="image/*"
                                            isImage={true}
                                            setFieldValue={
                                              formik.setFieldValue
                                            }
                                            isRequired={true}
                                            isMultiple={false}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </Paper>
                                </div>
                                {!readOnly && (
                                  <div className="col-md-2">
                                    {formik.values.questions_attributes.filter(
                                      (q) => !q._destroy
                                    ).length > 1 && (
                                      <IconButton
                                        onClick={() => {
                                          if (!question.id) {
                                            remove(questionIndex);
                                            return;
                                          }
                                          replace(questionIndex, {
                                            ...question,
                                            _destroy: true
                                          });
                                        }}
                                      >
                                        <CancelIcon />
                                      </IconButton>
                                    )}
                                    {showAddButton && (
                                      <IconButton
                                        onClick={() =>
                                          push(newEmptyQuestion)
                                        }
                                      >
                                        <AddCircleIcon />
                                      </IconButton>
                                    )}
                                  </div>
                                )}
                              </div>
                            )
                          );
                        }
                      );
                }}
              </FieldArray>
            </fieldset>
            {location?.state?.mode !== "view" && (
              <Button
                type="submit"
                className="primary-lg"
                data-toggle="tooltip"
                data-placement="top"
                disabled={!CanBeEditQuiz}
                text={buttons.submit}
                title={!CanBeEditQuiz ? quizzes.quizzeAnswered : ""}
                onClick={() => {
                  formik.submitForm();
                }}
              >
                Save Quiz
              </Button>
            )}
          </div>
        );
      }}
    </Formik>
  );
};

AddEditQuiz.propTypes = {
  location: PropTypes.object
};
export default withRouter(AddEditQuiz);
